/* eslint-disable no-undef */
/**
 *
 * encrypt helper
 *
 */
const CryptoJS = require('crypto-js');
/**
 * Encrypt a string
 *
 * @param  {string} message The message to be encrypted
 * @param  {string} passPhrase The pass code
 *
 */
export function encrypt(message, passPhrase) {
    return CryptoJS.TripleDES.encrypt(message, passPhrase).toString();
}

/**
 * Encrypt a string
 *
 * @param  {string} data The data to be decrypted
 * @param  {string} passPhrase The pass code
 *
 */
export function decrypt(data, passPhrase) {
    return CryptoJS.TripleDES.decrypt(data, passPhrase).toString(
        CryptoJS.enc.Utf8
    );
}

export function HashSha512(value) {
    return CryptoJS.SHA512(value).toString();
}
